import React from 'react'
import {Table} from "antd"

const ClubMemberFindTrackCommodity= ({ loading,datasource }) => {

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '账号',
            dataIndex: 'account',
            key: 'account',
        }, {
            title: '用户',
            dataIndex: 'nickname',
            key: 'nickname',
        }, {
            title: '商品名称',
            dataIndex: 'c_name',
            key: 'c_name',
        }, {
            title: '球台',
            dataIndex: 'table_name',
            key: 'table_name',
        }, {
            title: '购买时间',
            dataIndex: 'time',
            key: 'time',
        }, {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
        }, {
            title: '总金额',
            dataIndex: 'price',
            key: 'price',
        }, {
            title: '单价',
            dataIndex: 'uprice',
            key: 'uprice',
        },
    ]

    return (
        <div style={{padding: 16}}>
            <Table
                columns={columns}
                dataSource={datasource}
                loading={loading}
                title={() => '商品消费'}
            />
        </div>
    )

}
export default ClubMemberFindTrackCommodity


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackCommodity.js